import { QueryClient } from '@tanstack/react-query';
import React from 'react';
import { Store } from 'redux';

import UserGalleryLayout, { loader as galleryPageLoader } from './$username';
import UserGalleryFolder, {
  loader as galleryFolderLoader,
} from './$username.$folderId';
import UserGalleryIndex, {
  loader as galleryUserLoader,
} from './$username._index';
import UserGalleryFavorites, {
  loader as galleryFavoritesLoader,
} from './$username.favorites';
import GalleryImageEdit from './image.$imageId.edit';
import GalleryImage, {
  loader as galleryImageLoader,
} from './image.$imageId/route';
import GalleryUpload from './upload';

export default (queryClient: QueryClient, store: Store) => ({
  path: '/gallery',
  children: [
    {
      path: 'image/:imageId',
      loader: galleryImageLoader(queryClient),
      children: [
        {
          index: true,
          element: <GalleryImage />,
        },
        {
          path: 'edit',
          element: <GalleryImageEdit />,
        },
      ],
    },
    { path: 'upload', element: <GalleryUpload /> },
    {
      path: ':username',
      element: <UserGalleryLayout />,
      loader: galleryPageLoader(store),
      children: [
        {
          index: true,
          element: <UserGalleryIndex />,
          loader: galleryUserLoader(queryClient),
        },
        {
          path: 'favorites',
          element: <UserGalleryFavorites />,
          loader: galleryFavoritesLoader(queryClient),
        },
        {
          path: ':folderId',
          element: <UserGalleryFolder />,
          loader: galleryFolderLoader(queryClient),
        },
      ],
    },
  ],
});
